<template> 
<div>
    <b-card no-body>
        <b-card-header class="border-0 bgc-f7">
            <b-row>
                <b-col cols="12" lg="6">
                    <div class="text-primary cursor-pointer" @click="$router.go(-1)">
                        <b-icon icon="chevron-left"></b-icon>
                        Back
                    </div>
                </b-col>
                <b-col cols="12" lg="6">
                    <div class="d-flex align-items-center justify-content-end text-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" class="mr-1" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304c0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.9-22.2-26.4-22.2-56.8 0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144a31.76 31.76 0 0 0-34.4-5.4"/></svg>
                        <span>Share</span>
                    </div>
                </b-col>
            </b-row>
            <div class="text-center" v-if="is_loading">
                <el-button type="text" :loading="is_loading">Fetching project detail ...</el-button>
            </div>
        </b-card-header>
        <section id="property-listing" v-if="project">
            <div class="container pb-4">
               <b-row>
                    <b-col md="8">
                        <BasicInfo :project="project" :images="images" />
                        <div class="card" v-if="project.Property_Feature.length > 0">
                            <div class="card-body py-3">
                                <h3>Facilities</h3>
                                <div v-if="!Array.isArray(project.Property_Feature)">
                                    <div class="row">
                                        <div class="col-12 col-md-4 pb-3 d-flex align-items-center" v-for="(item, index) in project.Property_Feature" :key="index">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 448 512"><path fill="#0BC196" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                                            <span class="mx-2 text-md">{{ item }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-for="(feature, index) in project.Property_Feature" :key="index" class="feature">
                                        <p v-html="formatFeature(feature)"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header py-3 font-weight-bold">
                                Panel Bank &amp; Loan Margin
                            </div>
                            <div class="card-body py-3">
                                <b-row>
                                    <b-col md="3" class="mb-4 text-center" v-for="(bank, index) in project.project_banks" :key="index">
                                        <div class="mb-1">{{ bank.bank_name || bank.bank_detail.name }}</div>
                                        <el-progress
                                        type="circle"
                                        :percentage="parseFloat(bank.bank_loan_margin !== undefined ? bank.bank_loan_margin : (bank.loan_margin !== undefined ? bank.loan_margin : 0))"
                                        :width="65"
                                        color="#2DCE89"
                                        :text-color="'#000000'"
                                        ></el-progress>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                    <b-col md="4">
                        <UnitTypes :project="project" :unit_types="project.unit_types" />
                        <template v-if="project.project_source_type !== 'HESTIA'">
                            <Files :files="project.project_files" />
                        </template>
                        <template v-else>
                            <Files :files="files" />
                        </template>
                        <Fees :fees="project.project_setting" />
                    </b-col>
               </b-row>
            </div>
        </section>
    </b-card>
</div>
</template>
<style scoepd>
    .el-progress__text{
        font-size:12px !important
    }
</style>
<script>
import { Button, Progress, Image } from 'element-ui'
import { axios, services, getHeader, notifyFunctionMixin } from '@/assets/js/httpImports.js'
import PropertyTitle from './PropertyTitle.vue';
import BasicInfo from '@/views/PropertyListing/BasicInfo.vue'
import UnitTypes from '@/views/PropertyListing/UnitTypes.vue'
import Files from '@/views/PropertyListing/Files.vue'
import Fees from '@/views/PropertyListing/Fees.vue'
import { mapActions } from 'pinia'
import { usePMPStore } from '@/stores/pmpStore'


export default {
    mixins: [notifyFunctionMixin],
    components: {
        PropertyTitle,
        BasicInfo,
        UnitTypes,
        Files,
        Fees,
        [Button.name]: Button,
        [Progress.name]: Progress,
        [Image.name]: Image,
    },
    data(){
        return{
            project: null,
            is_loading: false,
            files: [],
            images: [],
        }
    },
    created(){
        this.getProjectDetail()
    },
    methods:{
        ...mapActions(usePMPStore, ['getProjectById']),
        async getProjectDetail(){
            this.is_loading = true
            if (!this.$route.query.source_type) {
                this.$router.push('/propertyListing')
                return
            } else {
                try{
                    const resp = await this.getProjectById(this.$route.params.project_id, this.$route.query.source_type)
                    if (resp.status === 200) {
                        this.project = resp.data.data

                        if (this.$route.query.source_type === 'PMP') {
                            this.processFeatures()
                        } else if (this.$route.query.source_type === 'HESTIA') {
                            this.getAttachments()
                        }
                    }
                }catch(e){
                    console.log('PMP Store (getProjects) failed:' + e.response)
                    throw e
                }
                this.is_loading = false
            }
        },
        getAttachments() {
            const params = {
                owner_id: this.$route.params.project_id,
                owner_type: 'project'
            }
            axios.get(services.attachment + 'attachments', {
                headers: getHeader(),
                params: params
            })
            .then(res => {
                res.data.data.forEach(item => {
                    if (item.ext.toLowerCase() === 'pdf') {
                        this.files.push(item)
                    } else {
                        this.images.push(item)
                    }
                })
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        processFeatures(){
            let property_feature_array = [];
            property_feature_array = this.project.Property_Feature ? this.project.Property_Feature.split(",") : [];
            Object.keys(property_feature_array).forEach(key =>{
              property_feature_array[key] = property_feature_array[key].trim();
            })
            this.project.Property_Feature = property_feature_array;
        },
        formatFeature(feature) {
            return feature.replace(/\n/g, '<br>');
        }
    }
};
</script>